import { useState, useEffect } from "react";
import { fetchContent } from "../../services/parameter.service";

const useContentAsociacionUsuariosFunciones = () => {
  const [asociacionUsuariosFunciones, setAsociacionUsuariosFunciones] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const getAsociacionUsuariosFunciones = async () => {
    setIsLoading(true);

    try {
      const responseContent = await fetchContent("asociacionusuariosfunciones");
      setAsociacionUsuariosFunciones(responseContent.data.list);

      setIsLoading(false);
    } catch (error) {
      console.error(" ERROR EN useContentAsociacionUsuariosFunciones --> ", error);
    }
  };

  useEffect(() => {
    getAsociacionUsuariosFunciones();
  }, []);

  return {
    asociacionUsuariosFunciones 
  };
};

export default useContentAsociacionUsuariosFunciones;
